
export const SERVER_URL = 'https://goldfish-app-5bk4i.ondigitalocean.app/'
// export const SERVER_URL = 'http://127.0.0.1:8000/'